module.exports = __webpack_public_path__ + "img/pause.8925762b.png";